import { message } from 'antd'
import { AxiosError } from 'axios'
import React, { useState } from 'react'

const useLocalStorage = (key: string, defaultValue: string) => {
  const [storageValue, setStorageValue] = useState(() => {
    try {
      const value = localStorage.getItem(key)
      if (value) {
        return JSON.parse(value)
      } else {
        localStorage.setItem(key, JSON.stringify(defaultValue))
        return defaultValue
      }
    } catch (error) {
      return defaultValue
    }
  })

  const setValue = (newValue: string) => {
    try {
      localStorage.setItem(key, JSON.stringify(newValue))
    } catch (e) {
      if ((e as AxiosError).response?.status === 500) {
        message.error((e as AxiosError).response?.data.detail)
      } else {
        console.log(e)
      }
    }
    setStorageValue(newValue)
  }

  return [storageValue, setValue]
}

export default useLocalStorage
